module.exports = __webpack_public_path__ + "static/floral 8 3000x3000-716d403f78b292b7cb1f927192fb7e5c.jpg";